module.exports = __webpack_public_path__ + "img/Background-Greeting-Cards-2366x901.53f192d5.jpeg";